<template>
  <el-card class="box-card full-screen">
    <div ref="pageHead" class="table-page-head">
      <el-form :inline="true" :model="queryForm">
        <el-form-item :label="$t('phone')">
          <el-input
            v-model="queryForm.phone"
            size="small"
            :placeholder="$t('phone')"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            size="small"
            @click="getList"
            :loading="isLoading"
            ><i class="el-icon-search"></i> {{ $t("query") }}</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div
      class="data-table"
      :style="{
        top: queryTableHeight,
        height: `calc(100% - ${queryTableHeight} - 70px)`,
      }"
    >
      <el-table
        :data="tableData.records"
        v-loading="isLoading"
        element-loading-background="rgba(255,255,255,0.4)"
        size="mini"
        height="100%"
      >
        <el-table-column prop="id" fixed="left" :label="$t('ID')" width="50">
        </el-table-column>
        <el-table-column
          prop="transferCode"
          fixed="left"
          :label="$t('applyCode')"
          width="160"
        >
          <template slot-scope="scope">{{ scope.row.transferCode }}</template>
        </el-table-column>
        <el-table-column
          prop="transferDate"
          :label="$t('transferDatePartner')"
          width="160"
        >
          <template slot-scope="scope">{{
            $manba(scope.row.transferDate).format("ymdhms")
          }}</template>
        </el-table-column>
        <el-table-column prop="amount" :label="$t('amount')" width="180">
          <template slot-scope="scope">
            <span class="franc">₣</span>{{ scope.row.amount.formatMoney(0) }}
          </template>
        </el-table-column>
        <el-table-column prop="status" :label="$t('status')" width="160">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0" class="text-primary">{{
              $t("checkPending")
            }}</span>
            <span v-if="scope.row.status == 1" class="text-success">{{
              $t("completeTransaction")
            }}</span>
            <span v-if="scope.row.status == 2" class="text-danger">{{
              $t("notApproved")
            }}</span>
            <span v-if="scope.row.status == 3" class="text-warning">{{
              $t("completeReversal")
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="bankName" :label="$t('bankName')" width="200">
          <template slot-scope="scope">{{ scope.row.bankName }}</template>
        </el-table-column>
        <el-table-column
          prop="bankAccount"
          :label="$t('bankAccount')"
          width="160"
        >
          <template slot-scope="scope">
            <div class="overstep-hidden">{{ scope.row.bankAccount }}</div>
          </template>
        </el-table-column>

        <el-table-column prop="partnerId" :label="$t('customerId')" width="160">
          <template slot-scope="scope">
            <div class="overstep-hidden">{{ scope.row.partnerId }}</div>
          </template>
        </el-table-column>

        <el-table-column
          prop="partnerName"
          :label="$t('partnerName')"
          width="160"
        >
          <template slot-scope="scope">
            <div class="overstep-hidden">{{ scope.row.partnerName }}</div>
          </template>
        </el-table-column>

        <el-table-column
          prop="partnerAccount"
          :label="$t('partnerAccount')"
          width="160"
        >
          <template slot-scope="scope">
            <div class="overstep-hidden">{{ scope.row.partnerAccount }}</div>
          </template>
        </el-table-column>

        <el-table-column prop="partnerPhone" :label="$t('phone')" width="160">
          <template slot-scope="scope">
            <div class="overstep-hidden">{{ scope.row.partnerPhone }}</div>
          </template>
        </el-table-column>

        <el-table-column
          prop="createdId"
          :label="$t('createId')"
          width="220"
        ></el-table-column>

        <el-table-column
          prop="createTime"
          :label="$t('creationTime')"
          width="200"
        >
          <template slot-scope="scope">{{
            $manba(scope.row.createTime).format("ymdhms")
          }}</template>
        </el-table-column>
        <el-table-column
          prop="verifyUser"
          :label="$t('Admin validation') + '' + ' ID'"
          width="220"
        ></el-table-column>

        <el-table-column
          prop="verifyTime"
          :label="$t('verifyTime')"
          width="200"
        >
          <template slot-scope="scope">{{
            $manba(scope.row.verifyTime).format("ymdhms")
          }}</template>
        </el-table-column>
        <el-table-column prop="verifyRemark" :label="$t('remark')" width="220">
          <template slot-scope="scope">
            <div class="overstep-hidden">{{ scope.row.verifyRemark }}</div>
          </template>
        </el-table-column>
        <el-table-column fixed="right" :label="$t('extend')" width="210">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.status == 0"
              type="primary"
              size="mini"
              @click="openCheckApply(scope.row)"
              >{{ $t("check") }}</el-button
            >
            <el-button v-else size="mini" disabled>{{ $t("check") }}</el-button>

            <el-button
              size="mini"
              v-if="scope.row.status == 0"
              @click="editBank(scope.row)"
              type="primary"
              >{{ $t("edit") }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      background
      layout="total,sizes,prev,pager,next,jumper"
      :total="tableData.total || 0"
      :page-sizes="[20, 30, 50, 100, 200]"
      :page-size="pageSize"
      :current-page="currentPage"
      @size-change="setPageSzie"
      @current-change="setCurrentChange"
      @prev-click="setCurrentChange"
      @next-click="setCurrentChange"
    />

    <el-drawer
      :title="$t('editAccount')"
      :visible.sync="editBankdrawer"
      :direction="'rtl'"
      :modal="false"
      :destroy-on-close="true"
      :wrapperClosable="false"
      :size="700"
    >
      <el-form :model="partnerForm" :rules="rules" ref="partnerForm">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('bankName')" prop="bankName">
              <el-input
                size="medium"
                v-model="partnerForm.bankName"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('bankAccount')" prop="bankAccount">
              <el-input
                size="medium"
                v-model="partnerForm.bankAccount"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('applyCode')" prop="transferCode">
              <el-input
                size="medium"
                v-model="partnerForm.transferCode"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$t('transferDatePartner')"
              prop="transferDate"
            >
              <el-input
                size="medium"
                v-model="partnerForm.transferDate"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('amount')" prop="amount">
              <el-input size="medium" v-model="partnerForm.amount"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item class="bottom-button">
          <el-button
            size="medium"
            type="primary"
            @click="updateSubmit('partnerForm')"
            :loading="isloading"
            >{{ $t("submit") }}</el-button
          >
        </el-form-item>
      </el-form>
    </el-drawer>

    <!-- 锁定/解锁账户弹框 -->

    <el-drawer
      :title="$t('partnerTransferCheck')"
      :visible.sync="partnerCheck.drawer"
      :direction="'rtl'"
      :modal="false"
      :destroy-on-close="true"
      :wrapperClosable="false"
      :size="700"
    >
      <el-form :model="partnerCheckForm" :rules="rules" ref="partnerCheckForm">
        <el-row :gutter="20">
          <el-form-item prop="id" style="display: none;">
            <el-input size="medium" v-model="partnerCheckForm.id" />
          </el-form-item>
          <el-col :span="12">
            <el-form-item :label="$t('partnerName')">
              <el-input
                v-model="partnerCheck.row.partnerName"
                size="small"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('bankName')">
              <el-input
                v-model="partnerCheck.row.bankName"
                size="small"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('partnerAccount')">
              <el-input
                v-model="partnerCheck.row.partnerAccount"
                size="small"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('phone')">
              <el-input
                v-model="partnerCheck.row.partnerPhone"
                size="small"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('applyCode')">
              <el-input
                v-model="partnerCheck.row.transferCode"
                size="small"
                disabled
              ></el-input>
            </el-form-item>

            <el-form-item :label="$t('transferDatePartner')">
              <el-input
                v-model="partnerCheck.row.transferDate"
                size="small"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('amount')">
              <el-input
                v-model="partnerCheck.row.amount"
                size="small"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-divider content-position="left">{{ $t("checkInfo") }}</el-divider>
          <el-form-item :label="$t('checkStatus')" prop="status">
            <el-radio v-model="partnerCheckForm.status" :label="1" border>{{
              $t("getApproved")
            }}</el-radio>
            <el-radio v-model="partnerCheckForm.status" :label="2" border>{{
              $t("notApproved")
            }}</el-radio>
            <el-radio v-model="partnerCheckForm.status" :label="3" border>{{
              $t("cancel")
            }}</el-radio>
          </el-form-item>
          <el-form-item :label="$t('checkRemark')" prop="verifyRemark">
            <el-input
              type="textarea"
              size="medium"
              v-model="partnerCheckForm.verifyRemark"
            ></el-input>
          </el-form-item>
        </el-row>
        <div class="bottom-button">
          <el-button
            v-if="!printParam"
            size="medium"
            type="primary"
            :loading="isLoading"
            @click="onSubmitCheckResult('partnerCheckForm')"
            >{{ $t("submit") }}</el-button
          >
          <el-button v-else size="medium" @click="printVisible = true">{{
            $t("printrRceipt")
          }}</el-button>
        </div>
      </el-form>
    </el-drawer>

    <el-dialog
      :title="$t('printrRceipt')"
      :visible.sync="printVisible"
      width="500px"
      :modal-append-to-body="false"
      :destroy-on-close="true"
      :show-close="false"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <print-credentials
        :param="printParam"
        :isClosePrint.sync="printVisible"
      />
    </el-dialog>
  </el-card>
</template>
<script>
import bank from "@/api/bank";
import printCredentials from "@/components/printCredentialsDeposit";
export default {
  name: "partnerTransferCheck",
  components: {
    printCredentials,
  },
  data() {
    return {
      queryForm: {},
      //table高度，动态设置
      queryTableHeight: String,
      //table显示内容
      tableData: {},
      //分页器默认参数
      pageSize: 20,
      currentPage: 1,
      //显示加载中
      isLoading: false,
      //右侧弹框
      editBankdrawer: false,
      partnerForm: { type: 1 },
      partnerCheckForm: {},

      printVisible: false,
      printParam: null,

      //addForm: { },
      partnerCheck: {
        drawer: false,
        form: {},
        row: {},
      },
    };
  },
  computed: {
    rules() {
      return {
        status: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
      };
    },
    //imgError () { return this.$store.state.system.imgError; },

    loginInfo() {
      return this.$store.state.globalParameter.loginInfo;
    },
  },
  methods: {
    /**查询列表 */
    getList() {
      let _this = this;
      _this.isLoading = true;
      bank.getPartnerPage({
        param: {
          current: _this.currentPage,
          size: _this.pageSize,
          ..._this.queryForm,
        },
        success: (res) => {
          _this.tableData = res.data || {};
          _this.isLoading = false;
        },
      });
    },

    setPageSzie(val) {
      this.pageSize = val;
      this.getList();
    },
    setCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    /**格式化地区 */

    //drawerOpen () { this.drawer = true; },
    /**提交新增新机构 */

    openCheckApply(row) {
      this.partnerCheck.row = row;
      this.partnerCheckForm = {
        phone: row.partnerPhone,
        amount: row.amount,
        status: status,
        id: row.id,
        partnerAccount: row.partnerAccount,
        transferCode: row.transferCode,
      };
      this.partnerCheck.drawer = true;
    },
    editBank(data) {
      let _this = this;

      _this.partnerForm = { type: 0 };
      if (data) _this.partnerForm = data;
      _this.editBankdrawer = true;
    },

    updateSubmit(formName) {
      let _this = this;
      _this.$refs[formName].validate((valid) => {
        if (valid) {
          _this.isloading = true;
          bank.updatePartnerDeposit({
            param: _this[formName],
            success: (res) => {
              if (res.code == 200) {
                _this.$message({
                  type: "success",
                  message: _this.$t("operateSuccessfully"),
                });
                _this.getList();
                _this.editBankdrawer = false;
              } else {
                _this.$message({ type: "warning", message: _this.$t(res.msg) });
              }
              _this.isloading = false;
            },
          });
        }
      });
    },

    onSubmitCheckResult(refName) {
      let _this = this;
      _this.$refs[refName].validate((valid) => {
        if (!valid) return false;
        bank.updatePartnerStatus({
          param: _this.partnerCheckForm,
          success: (res) => {
            if (res.code == 200) {
              _this.getList();
              _this.partnerCheck.drawer = false;
              _this.$message.success(_this.$t("operateSuccessfully"));
              _this.$set(_this, "printParam", res.data);
              _this.$set(_this, "printVisible", true);
            } else _this.$message.warning(this.$t(res.msg));
          },
        });
      });
    },
  },
  created() {},
  mounted() {
    let queryTableHeight = this.$refs.pageHead.offsetHeight + 15;
    this.queryTableHeight = queryTableHeight + "px";
    this.getList();
  },
};
</script>

<style lang="less" scoped></style>
